import { isSiteOptedOut } from '@atlassian/cross-join-nudges';
import { getInviteesFromExpApi, getUsersFromCollaborationGraph } from '@atlassian/invite-prompt';
import type { Invitees } from '@atlassian/invite-prompt';

export type ResolverInput = {
	userId: string | null;
	confluenceCloudId: string;
	pageId: string;
	jiraCloudId: string;
};

export const resolveInviteOnLinkInsert = async ({
	userId,
	confluenceCloudId,
	pageId,
	jiraCloudId,
}: ResolverInput): Promise<Invitees> => {
	if (!userId) {
		return [];
	}

	if (await isSiteOptedOut(confluenceCloudId)) {
		return [];
	}

	const collaborators = await getUsersFromCollaborationGraph(confluenceCloudId, userId);

	if (!collaborators || collaborators.length === 0) {
		return [];
	}

	const accountIds = collaborators.map((c) => c.id);

	const response = await getInviteesFromExpApi(
		jiraCloudId,
		confluenceCloudId,
		pageId,
		userId,
		accountIds,
	);

	if (response.ineligibilityReason === undefined || response.ineligibilityReason === null) {
		return collaborators.filter((c) => response.accountIds.includes(c.id));
	} else {
		return [];
	}
};
